import React from 'react';
import { Tabs } from 'antd';
import WhatsappConfigration from './whatsappConfigration';
import MassengerConfigration from './massengerConfigration';
import EmailConfigration from './emailConfigration';
const onChange = key => {

};

const items = [
    {
        key: '1',
        label: 'Whatsapp',
        children: <WhatsappConfigration />,
    },
    {
        key: '2',
        label: 'Massenger',
        children: <MassengerConfigration />,
    },
    {
        key: '3',
        label: 'Email',
        children: <EmailConfigration />,
    },
];
const OmniChannels = () => <Tabs defaultActiveKey="1" items={items} onChange={onChange} />;
export default OmniChannels;